import React, { ReactNode } from 'react';

import { Pressable, Text } from '@rbilabs/universal-components';
import { Animated } from 'react-native';

import { useReversedUIContext } from 'state/reversed-ui';
import { theme } from 'styles/configure-theme';
import { isNative } from 'utils/environment';

export const StyledCtaButton = Pressable.withConfig({
  display: 'flex',
  flexDirection: 'row',
  _web: {
    cursor: 'pointer',
  },
  fontSize: {
    base: 'sm',
    md: 'md',
  },
});

interface CtaButtonProps {
  text?: string;
  cta: () => void;
  icon?: ReactNode;
  enableTextFade?: boolean;
}

const CtaButton = ({ text, cta, icon, enableTextFade = false }: CtaButtonProps) => {
  const { reversedUI } = useReversedUIContext();

  const fadeAnim = React.useRef(new Animated.Value(0));
  React.useEffect(() => {
    if (text) {
      Animated.timing(fadeAnim.current, {
        toValue: 1,
        duration: 3000,
        useNativeDriver: isNative,
      }).start();
    }
  }, [text]);

  return (
    <StyledCtaButton onPress={cta} accessibilityRole="button">
      <Animated.View style={[{ opacity: enableTextFade ? fadeAnim.current : 1 }]}>
        <Text
          color={reversedUI ? theme.token('text-reversed') : theme.token('text-default')}
          pt="3px"
        >
          {text}
        </Text>
      </Animated.View>
      {icon}
    </StyledCtaButton>
  );
};

export default CtaButton;
